import React from 'react';
import { useLocation } from 'react-router-dom';
import { VippsLoginButton } from '../../VippsLoginButton';
import { InternalLinkType } from '../../../../../types/internalLinkType';
import { useDocumentUrlWithNode } from '../../../hooks/Documents/useDocumentUrl';
import useSelector from '../../../redux/typedHooks';

export interface VippsLoginBlockProps {
  value: {
    internalLink?: InternalLinkType;
    externalLink?: string;
  };
}

export const VippsLoginBlock = ({ value: { internalLink, externalLink } }: VippsLoginBlockProps) => {
  const location = useLocation();
  const baseUrl = useSelector((state) => state.application.baseUrl);
  const resolvedInternalLink = useDocumentUrlWithNode(internalLink);
  const returnUrl = internalLink ? `${baseUrl}${resolvedInternalLink}${location.search}` : externalLink;
  return <VippsLoginButton returnUrl={returnUrl} />;
};
